<template>
    <div>
        <v-card class="mx-auto">
        <v-toolbar color="secondary" dark height="45">
            <v-toolbar-title class="text-body-1">
                <v-icon left class="mr-2" size="20">mdi-vector-link</v-icon>{{$t('PANEL.USER.NAVIGATION.TITLE')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        </v-card>
        <v-card class="mx-auto">

        <v-navigation-drawer width="100%" permanent>
            <v-list>

            <v-list-item :key="key" v-for="(nav, key) in userNavigation" v-show="nav.icon !== ''" link :to="`/settings/user-management/${nav.link}`">

                <v-list-item-icon class="my-3">
                <v-icon>{{nav.icon}}</v-icon>
                </v-list-item-icon>

                <v-list-item-content class="py-0">
                <v-list-item-title class="text-body-2">{{nav.name}}</v-list-item-title>
                </v-list-item-content>
                
            </v-list-item>

            </v-list>
        </v-navigation-drawer>
        </v-card>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: 'UserOperationsNavigation',
    computed: {
        ...mapState({
            userNavigation: state => state.systemTree.panel_settings.child.user_management.child
        }),
    }
}
</script>